function setValue(expression, value, scope, separator = '.') {
    const keys = expression.split(separator);
    const set = (key, add) => {
        if (add) {
            if (typeof scope.set === 'function') {
                scope.set(key, value);
            }
            else {
                scope[key] = value;
            }
            return false;
        }
        if (typeof scope.set === 'function') {
            if (!scope.has(key)) {
                scope.set(key, {});
            }
            scope = scope.get(key);
        }
        else {
            scope = scope[key] || {};
        }
        return true;
    };
    while (set(keys.shift(), !keys.length)) {
        //
    }
}
function getValue(expression, scope, defaultValue, separator = '.') {
    const keys = expression.split(separator);
    const get = (key) => {
        if (typeof scope.get === 'function') {
            return scope.get(key);
        }
        return scope[key];
    };
    while ((scope = get(keys.shift())) && keys.length) {
        //
    }
    return scope !== null && scope !== void 0 ? scope : defaultValue;
}

export { getValue, setValue };
//# sourceMappingURL=value-utils.js.map
